'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _makeComponentIntl = require('common/utils/make-component-intl');

var _makeComponentIntl2 = _interopRequireDefault(_makeComponentIntl);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _constants = require('ui/signature-modal/constants');

var _constants2 = _interopRequireDefault(_constants);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _tetherToggle = require('ui/tether-toggle');

var _tetherToggle2 = _interopRequireDefault(_tetherToggle);

var _editSignatureModal = require('signer/components/common/signature-modal/edit-signature-modal');

var _editSignatureModal2 = _interopRequireDefault(_editSignatureModal);

var _logo = require('./logo.jsx');

var _logo2 = _interopRequireDefault(_logo);

var _blocks = require('ui/blocks');

require('./style.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MenuLink = function MenuLink(props) {
    return _react2['default'].createElement(_blocks.Box, _extends({
        className: 'm-app-header--menu-item m-app-header--menu-item--hoverable',
        color: 'ashen',
        hoverColor: 'black',
        is: 'a',
        py: 3,
        px: 3,
        fontSize: 6,
        display: 'block'
    }, props));
};

// TODO: HelloFax & HelloSign header files should NOT be together - separate this stuff (CC)
// In-app top bar
var AppTopBar = _react2['default'].createClass({
    displayName: 'AppTopBar',


    propTypes: {
        'siteCode': _react.PropTypes.string.isRequired, // S or F
        'showUpgradeButton': _react.PropTypes.bool,
        'emailAddress': _react.PropTypes.string,
        'name': _react.PropTypes.string,
        'primarySignatureGuid': _react.PropTypes.string,
        'numDocsLeft': _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
        'numApiDocsLeft': _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
        'numTemplatesLeft': _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
        'numFaxPagesLeft': _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
        'minimalDisplay': _react.PropTypes.bool, // Only show the account menu (default is false)
        'disableAccountMenu': _react.PropTypes.bool, // Disable the account menu dropdown menu (default is false)
        'hideEmailAddress': _react.PropTypes.bool, // Hide the email address (default is false)
        'signatureModalProps': _react.PropTypes.object, // Signature modal props
        'showApiCredits': _react.PropTypes.bool
    },

    //  ----  LIFECYCLE  ----------------------------------

    getDefaultProps: function getDefaultProps() {
        return {
            'showUpgradeButton': true,
            'minimalDisplay': false,
            'hideEmailAddress': false,
            'disableAccountMenu': false,
            'showApiCredits': false
        };
    },
    getInitialState: function getInitialState() {
        return {
            'signatureModalIsShown': false,
            'signatureModalTab': _constants2['default'].TAB_SAVED
        };
    },
    componentDidMount: function componentDidMount() {
        // CSRF Token is used in the in-app signature modal.
        if (this.props.app && this.props.signatureModalProps) {
            this.props.app.csrfToken = this.props.signatureModalProps.csrfToken;
        }
    },


    //  ----  BEHAVIOR  -----------------------------------

    showHowItWorks: function showHowItWorks() {
        var site = _hfReactHelper2['default'].HfSites.getSite(this.props.siteCode);
        document.location = _hfReactHelper2['default'].urlHelper('account/sendDemo', site);
    },
    showSignatureModal: function showSignatureModal(evt) {

        evt.preventDefault();
        evt.stopPropagation();

        this.setState({
            'signatureModalIsShown': true
        });
    },
    hideSignatureModal: function hideSignatureModal() {
        this.setState({
            'signatureModalIsShown': false,
            'signatureModalTab': _constants2['default'].TAB_SAVED
        });
    },
    showInviteFriendsModal: function showInviteFriendsModal(evt) {

        evt.preventDefault();

        var site = _hfReactHelper2['default'].HfSites.getSite(this.props.siteCode);
        var url = _hfReactHelper2['default'].urlHelper('home/inviteFriends', site);

        $.fancybox({
            'type': 'iframe',
            'showCloseButton': false,
            'scrolling': 'no',
            'href': url,
            'padding': 0,
            'margin': 0,
            'autoDimensions': true,
            onStart: function onStart() {
                $('#fancybox-overlay').addClass('m-fancybox-modal-overlay settings-modal invite-friends is-hidden');
                $('#fancybox-wrap').addClass('m-fancybox-modal-wrap settings-modal invite-friends is-hidden');
                $('#fancybox-inner').addClass('m-fancybox-modal-inner settings-modal invite-friends');
            },
            onComplete: function onComplete() {
                $.fancybox.center();
                $('#fancybox-overlay, #fancybox-wrap').removeClass('is-hidden');
            },
            onClosed: function onClosed() {
                $('#fancybox-overlay, #fancybox-wrap, #fancybox-inner').attr('class', '');
            }
        });
    },
    updatePrimarySignature: function updatePrimarySignature(signature) {

        window.primarySignatureGuid = signature ? signature.guid : void 0;

        if (this.state.signatureModalTab == _constants2['default'].TAB_SAVED) {

            // Mark the current signature as primary and close the modal
            signature.markAsPrimary().then(function () {
                this.hideSignatureModal();
            }.bind(this))['catch'](function (err) {
                // Fail silently
                console.error('Could not mark signature as primary', err);
            }.bind(this));
        } else {

            // Show the saved signature tab after a new one has been created
            this.setState({
                'signatureModalTab': _constants2['default'].TAB_SAVED
            });
        }
    },
    onSignatureModalTabSelected: function onSignatureModalTabSelected(tabId) {
        this.setState({
            'signatureModalTab': tabId
        });
    },


    //  ----  RENDERING  ----------------------------------

    renderAccountMenu: function renderAccountMenu(site, trigger) {
        var disableAccountMenu = this.props.disableAccountMenu;

        var settingsUrl = _hfReactHelper2['default'].urlHelper('home/myAccount', site);
        var logoutUrl = _hfReactHelper2['default'].urlHelper('account/logOut', site);
        var signatureGuid;
        var freeDocsLink;

        if (window.primarySignatureGuid === null) {
            // In this case we don't have a primary signature because it just got deleted
            signatureGuid = null;
        } else {
            signatureGuid = window.primarySignatureGuid || this.props.primarySignatureGuid;
        }

        var items = [undefined, undefined, _react2['default'].createElement(
            MenuLink,
            { key: 2, href: settingsUrl, fontWeight: 'normal' },
            'Settings'
        ), _react2['default'].createElement(
            MenuLink,
            { key: 3, href: logoutUrl, fontWeight: 'normal' },
            'Logout'
        )];

        if (_hfReactHelper2['default'].HfSites.isHelloSign(site)) {

            // Signature
            var name;
            var sig;
            var sigClassNames = (0, _classnames2['default'])({
                'm-app-topbar--menu--signature--sig': true,
                'no-sig': !signatureGuid,
                'l-margin-t-20': !this.props.name
            });
            if (this.props.name) {
                name = _react2['default'].createElement(
                    _blocks.Box,
                    { fontSize: 6, className: 'm-app-topbar--menu--signature--name' },
                    this.props.name
                );
            }
            if (signatureGuid) {
                sig = _react2['default'].createElement(
                    'div',
                    { className: sigClassNames },
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-app-topbar--menu--signature--image' },
                        _react2['default'].createElement('img', { src: _hfReactHelper2['default'].urlHelper('attachment/view?sig_guid=' + signatureGuid, site) })
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-app-topbar--menu--signature--edit' },
                        _react2['default'].createElement(
                            'a',
                            { href: 'javascript:;', onClick: this.showSignatureModal },
                            'Edit signature'
                        )
                    )
                );
            } else {
                sig = _react2['default'].createElement(
                    'div',
                    { className: sigClassNames, onClick: this.showSignatureModal },
                    _react2['default'].createElement('img', { src: require('./plus_icon@2x.png') }),
                    _react2['default'].createElement(
                        _blocks.Box,
                        { is: 'span', fontSize: 6 },
                        'Create a signature'
                    )
                );
            }
            items[0] = _react2['default'].createElement(
                _blocks.Box,
                { px: 3, key: 0, className: 'm-app-header--menu-item' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-app-topbar--menu--signature' },
                    name,
                    sig
                )
            );

            // HS Credits
            var numDocsLeft = this.props.numDocsLeft === null ? 'Unlimited' : this.props.numDocsLeft;
            var numTemplatesLeft = this.props.numTemplatesLeft === null ? 'Unlimited' : this.props.numTemplatesLeft;
            if (this.props.showUpgradeButton) {
                freeDocsLink = _react2['default'].createElement(
                    _blocks.Box,
                    { is: 'a', display: 'block', py: 2, href: '', onClick: this.showInviteFriendsModal },
                    'Get free documents'
                );
            }

            var apiCredits = '';
            if (this.props.showApiCredits) {
                var numApiDocsLeft = this.props.numApiDocsLeft === null ? 'Unlimited' : this.props.numApiDocsLeft;
                apiCredits = _react2['default'].createElement(
                    'div',
                    null,
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-app-topbar--menu--credits--title' },
                        'REMAINING API CREDITS'
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-app-topbar--menu--credits--line' },
                        numApiDocsLeft + ' API document' + (numApiDocsLeft !== 1 ? 's' : '')
                    )
                );
            }

            items[1] = _react2['default'].createElement(
                _blocks.Box,
                { px: 3, key: 1, className: 'm-app-header--menu-item' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-app-topbar--menu--credits' },
                    apiCredits,
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-app-topbar--menu--credits--title' },
                        'REMAINING CREDITS'
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-app-topbar--menu--credits--line' },
                        numDocsLeft + ' document' + (numDocsLeft !== 1 ? 's' : '')
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-app-topbar--menu--credits--line' },
                        numTemplatesLeft + ' template' + (numTemplatesLeft !== 1 ? 's' : '')
                    ),
                    freeDocsLink
                )
            );
        } else {

            // HF Credits
            var getFreePagesUrl = _hfReactHelper2['default'].urlHelper('account/gettingStarted', site);
            var numFaxPagesLeft = this.props.numFaxPagesLeft === null ? 'Unlimited' : this.props.numFaxPagesLeft;
            items[1] = _react2['default'].createElement(
                _blocks.Box,
                { px: 3, key: 1, className: 'm-app-header--menu-item' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-app-topbar--menu--credits', key: 1 },
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-app-topbar--menu--credits--title' },
                        'REMAINING CREDITS'
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-app-topbar--menu--credits--line' },
                        numFaxPagesLeft + ' fax page' + (numFaxPagesLeft !== 1 ? 's' : '')
                    ),
                    _react2['default'].createElement(
                        _blocks.Box,
                        { display: 'block ', is: 'a', py: 2, href: getFreePagesUrl },
                        'Get free pages'
                    )
                )
            );
        }

        return _react2['default'].createElement(
            _tetherToggle2['default'],
            {
                anchor: trigger,
                justify: 'right',
                disabled: disableAccountMenu
            },
            _react2['default'].createElement(
                'div',
                { className: 'm-app-topbar--account-menu' },
                items
            )
        );
    },
    signatureModalProps: function signatureModalProps() {
        var app = this.props.app || window.app;
        if (this.props.signatureModalProps.settings) {
            app.isMobile = false;
            app.user.settings = Object.assign(app.user.settings || {}, this.props.signatureModalProps.settings);
        }
        return {
            'app': app,
            'buttonText': this.state.signatureModalTab === _constants2['default'].TAB_SAVED ? 'Select' : 'Save',
            'emailGuid': this.props.signatureModalProps.emailGuid,
            'emailUploadAddress': this.props.signatureModalProps.emailUploadAddress,
            'type': this.props.signatureModalProps.signatureType,
            'onComplete': this.updatePrimarySignature,
            'onSelectTab': this.onSignatureModalTabSelected,
            'onClose': this.hideSignatureModal,
            'initialTab': this.state.signatureModalTab,
            'intl': this.props.intl
        };
    },
    render: function render() {
        var responsive = this.props.responsive;


        var isHf = _hfReactHelper2['default'].HfSites.isHelloFax(this.props.siteCode);
        var site = _hfReactHelper2['default'].HfSites.getSite(this.props.siteCode);
        var homeUrl = _hfReactHelper2['default'].urlHelper('home/index', site);
        var logoUrl = isHf ? require('./logo-hf.svg') : require('./logo.svg');
        var signDocs;
        var seeHowBtn;
        var upgradeBtn;
        var acctMenu;
        var emailAddressLink;
        var signatureModal;

        var topBarMenuClasses = (0, _classnames2['default'])({
            'm-app-topbar--menu': true,
            'is-disabled': this.props.disableAccountMenu
        });

        var meAndOthersParams = 'me=1';

        if (!this.props.minimalDisplay) {

            if (isHf) {

                seeHowBtn = _react2['default'].createElement(_button2['default'], {
                    key: 'see-how-it-works-button',
                    buttonText: 'See how it works',
                    buttonLink: '',
                    buttonColor: 'white',
                    buttonTextColor: 'ashen',
                    buttonClass: 'border-1-ashen',
                    buttonModuleClass: 'm-app-topbar--see-how-btn',
                    onClick: this.showHowItWorks });
            } else {

                var items = [_react2['default'].createElement(
                    MenuLink,
                    { key: 'me', href: _hfReactHelper2['default'].urlHelper('sign', site) },
                    'Just me'
                ), _react2['default'].createElement(
                    MenuLink,
                    { key: 'me-and-others', href: _hfReactHelper2['default'].urlHelper('home/request?' + meAndOthersParams, site) },
                    'Me & others'
                ), _react2['default'].createElement(
                    MenuLink,
                    { key: 'others', href: _hfReactHelper2['default'].urlHelper('home/request', site) },
                    'Just others'
                )];

                var signDocsTrigger = _react2['default'].createElement(
                    'div',
                    { className: 'm-app-topbar--signdocs' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-app-topbar--signdocs--title' },
                        _react2['default'].createElement(
                            'span',
                            { className: 'm-app-topbar--signdocs--icon' },
                            _react2['default'].createElement('img', { className: 'm-app-topbar--signdocs--icon--img', src: require('./signdoc_icon@2x.png') })
                        ),
                        _react2['default'].createElement(
                            'span',
                            { className: 'm-app-topbar--signdocs--title--text' },
                            'Sign documents'
                        )
                    )
                );

                signDocs = _react2['default'].createElement(
                    _blocks.Box,
                    { display: 'inline-block' },
                    _react2['default'].createElement(
                        _tetherToggle2['default'],
                        {
                            anchor: signDocsTrigger,
                            justify: 'right'
                        },
                        items
                    )
                );
            }
        }

        if (!this.props.minimalDisplay && this.props.showUpgradeButton) {
            upgradeBtn = _react2['default'].createElement(
                'a',
                { href: _hfReactHelper2['default'].urlHelper('info/pricing', site), className: 'm-button bg-cerulean m-app-topbar--upgrade-btn hbg-castle-rock hc-white c-white progress-button state-loading' },
                'Upgrade'
            );
        }

        if (!this.props.hideEmailAddress) {

            // Hidden signature modal
            if (!isHf && this.state.signatureModalIsShown) {
                signatureModal = _react2['default'].createElement(_editSignatureModal2['default'], this.signatureModalProps());
            }

            // Render the email address link
            emailAddressLink = _react2['default'].createElement(
                'div',
                { className: 'm-app-topbar--menu--title m-app-topbar--menu--title-email' },
                _react2['default'].createElement(
                    'span',
                    { className: 'm-app-topbar--menu--title--text' },
                    this.props.emailAddress
                ),
                _react2['default'].createElement(
                    'span',
                    { className: 'm-app-topbar--menu--title--icon' },
                    _react2['default'].createElement('img', { src: require('./menu_arrow@2x.png') })
                )
            );

            acctMenu = this.renderAccountMenu(site, emailAddressLink);
        }

        return _react2['default'].createElement(
            'div',
            { className: 'm-app-topbar' },
            signatureModal,
            _react2['default'].createElement(
                _blocks.Flex,
                { justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' },
                _react2['default'].createElement(_logo2['default'], { href: homeUrl, src: logoUrl, alt: isHf ? 'HelloFax' : 'HelloSign', width: '229', height: '35' }),
                _react2['default'].createElement(
                    'div',
                    { className: 'm-app-topbar--actions' },
                    signDocs,
                    seeHowBtn,
                    upgradeBtn,
                    _react2['default'].createElement(
                        'div',
                        { className: topBarMenuClasses },
                        _react2['default'].createElement(
                            _blocks.Box,
                            { display: 'inline-block' },
                            acctMenu
                        )
                    )
                )
            )
        );
    }
});

module.exports = (0, _makeComponentIntl2['default'])(AppTopBar);


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/header/index.jsx
 ** module id = 770
 ** module chunks = 0 1
 **/